/**
 * An Form Error class that keeps track of the fieldName and possible multiple
 * reasons for the error, which should be FormError or Error themselves.
 */
export default function FormError(message, fieldName, reasons) {
    Error.call(this)
    this.message = message
    this.fieldName = fieldName
    if (reasons) {
        this.reasons = Array.isArray(reasons) ? reasons : [reasons]
    }
}

FormError.prototype = Object.create(Error.prototype)

FormError.prototype.toString = function () {
    return (
        'FieldName: ' +
        this.fieldName +
        ', Message: ' +
        this.message +
        (this.reasons && ', Reasons: [' + this.reasons.join() + '] ')
    )
}

/**
 * A helper function to extract the form error for a specific field.
 *
 * @param  {FormError}  error  raw error object of the whole model
 * @param  {(string|null)}  fieldName  of the field to bind.
 */
export function getFormFieldError(error, fieldName) {
    if (!error || !Array.isArray(error.reasons)) {
        return null
    }
    const flatError = getFlatErrorList(error)

    return flatError.find(error => error.fieldName === fieldName) || null
}

/**
 * A helper function to get all field errors in the error object.
 *
 * @param  {FormError}  error  raw error object of the whole model
 */
export function getFlatErrorList(error) {
    if (error && Array.isArray(error.reasons)) {
        return error.reasons.reduce((fieldErrors, error) => {
            if (error instanceof FormError) {
                if (error.fieldName) {
                    fieldErrors.push(error)
                }
                if (error.reasons) {
                    return fieldErrors.concat(getFlatErrorList(error))
                }
            }
            return fieldErrors
        }, [])
    }
    return []
}
